<!--
  Copyright (C) 2022 - Jeci SARL - https://jeci.fr

  This program is free software: you can redistribute it and/or modify
  it under the terms of the GNU Affero General Public License as
  published by the Free Software Foundation, either version 3 of the
  License, or (at your option) any later version.

  This program is distributed in the hope that it will be useful,
  but WITHOUT ANY WARRANTY; without even the implied warranty of
  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
  GNU Affero General Public License for more details.

  You should have received a copy of the GNU Affero General Public License
  along with this program.  If not, see https://www.gnu.org/licenses/agpl-3.0.html.
-->

<template>
  <div>
    <div class="field">
      <FieldLabel
        :label="$t('dashboardAdmin.blockEditor.nodeId')"
        :help="$t('dashboardAdmin.blockEditor.help.nodeId')"
        :example="$t('dashboardAdmin.blockEditor.examples.nodeId')"
      />
      <div class="input-wrapper" @click="$emit('open-file-browser')">
        <PrimeInputText
          :model-value="config.id"
          class="input-full clickable"
          readonly
          :placeholder="$t('dashboardAdmin.blockEditor.clickToSelectFile')"
        />
      </div>
    </div>
  </div>
</template>

<script>
import InputText from "primevue/inputtext";
import FieldLabel from "@/components/dashboard/editor/FieldLabel.vue";

export default {
  name: "PdfImageConfig",
  components: {
    PrimeInputText: InputText,
    FieldLabel,
  },
  props: {
    config: {
      type: Object,
      required: true,
    },
  },
  emits: ["update:config", "open-file-browser"],
};
</script>

<style scoped>
.field {
  margin-bottom: 1rem;
}

.input-wrapper {
  cursor: pointer;
}

.input-full {
  width: 100%;
}

.clickable {
  cursor: pointer;
}
</style>
